import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconStoreFill = ({ width = 24, height = 24, ...props }: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        d='M15 14.435a4.947 4.947 0 003 1.015c.79 0 1.56-.19 2.25-.543V19.5a1.502 1.502 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-4.593c.69.353 1.46.543 2.25.543 1.09 0 2.143-.362 3-1.015a4.947 4.947 0 003 1.015c1.09 0 2.143-.362 3-1.015zM19.064 3.006a1.51 1.51 0 011.276.96l.039.115.014.055 1.34 6.206.001.007c.01.049.016.1.016.151a3.75 3.75 0 01-1.87 3.242l-.071.04a3.746 3.746 0 01-.44.207l-.04.016a3.758 3.758 0 01-1.024.23l-.055.005a3.712 3.712 0 01-.432.005c-.019 0-.038-.003-.057-.005l-.103-.007a3.72 3.72 0 01-.673-.125A3.749 3.749 0 0115 12.748a3.75 3.75 0 01-2.66 1.486l-.1.006-.06.005a3.747 3.747 0 01-.362 0c-.019 0-.038-.003-.057-.005l-.103-.007a3.72 3.72 0 01-.673-.125A3.749 3.749 0 019 12.748a3.75 3.75 0 01-2.317 1.438l-.033.005a3.719 3.719 0 01-.31.042l-.1.007-.06.005a3.744 3.744 0 01-.431-.005l-.055-.005a3.738 3.738 0 01-.764-.142l-.022-.005-.173-.058-.055-.021-.06-.024a3.754 3.754 0 01-.7-.365h-.002A3.757 3.757 0 012.25 10.5a.755.755 0 01.017-.158l1.34-6.206.014-.055A1.511 1.511 0 015.057 3h13.886l.121.006z'
        fill='#8E98A0'
        fillOpacity={0.6}
      />
    </svg>
  )
}

export default memo(IconStoreFill)
